import { useContext, useState } from "react";
import Input from "../atoms/Input";
import { MultiContext } from "../../Context";
import Button from "../atoms/Button";

export default function NewIgnored({ className = "" }) {
  const multiCtx = useContext(MultiContext);
  const label = "ignored";

  const [name, setName] = useState("");

  const onChangeName = (e) => setName(e.target.value);

  return (
    <form
      className={className + " input-group input-group-sm my-3"}
      onSubmit={(e) => {
        multiCtx.addIgnore(e, name);
        setName("");
      }}>
      <Input
        required={true}
        value={name}
        onChange={onChangeName}
        placeholder="New Ignore Item"
      />
    </form>
  );
}
